<template>
  <div class="overdue-table">
    <vxe-toolbar size="mini">
      <template
        v-slot:buttons
        v-if="
          contractStatus == '' ||
          contractStatus == 'ZT06' ||
          contractStatus == 'ZT05' ||
          contractStatus == 'ZT061' ||
          contractStatus == 'ZT051'
        "
      >
        <el-button type="primary" size="small" class="vxe-btn-primary" @click="addNewRowHandler"
          >新增</el-button
        >
        <el-button
          size="small"
          type="danger"
          class="vxe-btn-delete"
          @click="deleteBtnClickHandler()"
          >删除</el-button
        >
      </template>
    </vxe-toolbar>
    <!-- 表格区域 -->
    <vxe-grid
      border
      auto-resize
      resizable
      show-overflow
      keep-source
      ref="xTableRef"
      class="vxe-table-element"
      size="mini"
      align="left"
      :data="tableData"
      :columns="tableColumnsList"
      :edit-rules="tableRules"
      :edit-config="editConfig"
      :valid-config="{ autoPos: true, message: 'inline' }"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      @edit-closed="closeEditTableHandler"
    >
    </vxe-grid>
  </div>
</template>

<script>
  export default {
    name: 'OverdueInterestTable',
    props: {
      contractStatus: {
        type: String,
        default: () => '',
      },
      orderOverdueInterestList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableData: [],
        selectionList: [],
        editConfig: {},
        tableRules: {},
        orderDetailDelIds: [],
      };
    },
    computed: {
      tableColumnsList() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '序号', width: 50 },
          {
            field: 'triggerCondition',
            title: '触发条件',
            align: 'center',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
              options: [
                {
                  label: '开票后',
                  value: 1,
                },
                {
                  label: '发货后',
                  value: 2,
                },
              ],
              events: {
                input: (obj) =>
                  this.updateCol(obj.row['triggerCondition'], obj.row, 'triggerCondition'),
              },
            },
          },
          {
            field: '',
            title: '天数',
            align: 'center',
            children: [
              {
                field: 'days',
                title: '天数',
                align: 'center',
                editRender: {
                  name: 'ElInput',
                },
                slots: {
                  default: ({ row }) => {
                    return [<span>{row['days']}</span>];
                  },
                  edit: ({ row }) => {
                    return [
                      <InputNumberAd
                        value={row['days']}
                        max={999999999.999999}
                        min={0}
                        precision={0}
                        onInput={(val) => this.updateCol(val, row, 'days')}
                      ></InputNumberAd>,
                    ];
                  },
                },
              },
              {
                field: 'dateType',
                title: '天数类型',
                align: 'center',
                editRender: {
                  name: 'ElSelect',
                  props: {
                    clearable: true,
                  },
                  options: [
                    {
                      label: '自然日',
                      value: 1,
                    },
                    {
                      label: '工作日',
                      value: 2,
                    },
                  ],
                  events: {
                    input: (obj) => this.updateCol(obj.row['dateType'], obj.row, 'dateType'),
                  },
                },
              },
            ],
          },
          {
            field: '',
            title: '应收费用',
            align: 'center',
            children: [
              {
                field: 'receivableCost',
                title: '费用',
                align: 'center',
                editRender: {
                  name: 'ElInput',
                },
                slots: {
                  default: ({ row }) => {
                    return [<span>{row['receivableCost']}</span>];
                  },
                  edit: ({ row }) => {
                    return [
                      <InputNumberAd
                        value={row['receivableCost']}
                        max={999999999.999999}
                        min={0}
                        precision={2}
                        onInput={(val) => this.updateCol(val, row, 'receivableCost')}
                      ></InputNumberAd>,
                    ];
                  },
                },
              },
              {
                field: 'receivableType',
                title: '应收费用类型',
                align: 'center',
                editRender: {
                  name: 'ElSelect',
                  props: {
                    clearable: true,
                  },
                  options: [
                    {
                      label: '元',
                      value: 1,
                    },
                    {
                      label: '%',
                      value: 2,
                    },
                  ],
                  events: {
                    input: (obj) =>
                      this.updateCol(obj.row['receivableType'], obj.row, 'receivableType'),
                  },
                },
              },
            ],
          },
        ];
      },
    },
    methods: {
      // 更新列
      updateCol(val, row, field) {
        console.log(field, '当前字段', val, row);
        row[field] = val;
        let xTable = this.$refs.xTableRef;
        xTable.updateData();
      },
      // 关闭表格编辑
      closeEditTableHandler() {
        console.log(this.getTableData(), '???');
        this.$emit('closeTableHandler', this.getTableData());
      },
      // 选择表格
      handleSelectionChange(row) {
        this.selectionList = row.selection;
      },
      async addNewRowHandler() {
        const $table = this.$refs.xTableRef;
        const { row } = await $table.insertAt({}, 0);
        await $table.setActiveRow(row);
      },
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.orderDetailDelIds = [...this.orderDetailDelIds, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
      },
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData.map((item) => {
          return {
            ...item,
          };
        });
      },
      // 获取表格数据
      getValidateTableData() {
        return new Promise((resolve, reject) => {
          const $table = this.$refs.xTableRef;
          const tableData = $table.getTableData().fullData;
          $table.validate((valid) => {
            if (valid && tableData.length) {
              console.log(tableData);
              const newData = tableData.map((item) => {
                return {
                  ...item,
                  id:
                    ['true', true].includes(this.$route.query.copy) ||
                    ['true', true].includes(this.$route.query.isCopy)
                      ? ''
                      : item.id,
                  orderType: this.$route.query.type,
                };
              });
              console.log(newData, '数据');
              resolve({
                orderOverdueInterestList: newData,
                // orderDetailDelIds: [...this.orderDetailDelIds],
              });
            } else {
              this.$message.error('请补充逾期利息数据');
              reject({ orderOverdueInterestList: [] });
            }
          });
        });
      },
    },
    watch: {
      // 反填表格数据
      orderOverdueInterestList: {
        handler(val) {
          if (val && Array.isArray(val) && val.length > 0) {
            this.fullTableData(val);
          }
        },
        immediate: true,
        deep: true,
      },
      contractStatus: {
        handler(val) {
          if (val == '' || val == 'ZT06' || val == 'ZT05' || val == 'ZT061' || val == 'ZT051') {
            this.editConfig = { trigger: 'click', mode: 'row' };
          } else {
            this.editConfig = {};
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .overdue-table {
    ::v-deep {
      .vxe-table--empty-placeholder {
        top: 70px !important;
      }
    }
  }
</style>
